//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { DataProvider } from '../../helpers'
import { Enums } from '../common'
import { ICopyable, IJsonSerializable, IOpChangeState, IReferenceType } from '../util/interfaces'
import { OpDistributor } from './op-distributor'

export class OpTaskGroup
    implements IReferenceType, IOpChangeState, ICopyable<OpTaskGroup>, IJsonSerializable
{
    // #region Properties

    public idTaskGroup: number

    /**
     * In C# class there is typo - 'Parrent' instead of 'Parent'
     * */
    public idParentGroup: number

    public name: string

    public dateCreated: Date

    public idDistributor: number

    // #endregion

    // #region Naviagtion properties

    public parentGroup: OpTaskGroup

    public distributor: OpDistributor

    // #endregion

    // #region Ctor

    constructor(opObj: any) {
        if (opObj instanceof OpTaskGroup) {
            this.copy(<OpTaskGroup>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    // #endregion

    // #region IReferenceType implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdTaskGroup
    }

    public getReferenceKey(): number {
        return this.idTaskGroup
    }

    public getReferenceValue(): any {
        return this
    }

    public toString(): string {
        return this.name
    }

    // #endregion

    // #region IOpChangeState implementation

    public opState: Enums.OpChangeState

    // #endregion

    // #region ICopyable implementation

    public copy(sourceObject: OpTaskGroup, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {
        if (sourceObject == null) {
            return
        }

        if (includeNavigationProperties) {
            if (sourceObject.distributor != null) {
                this.distributor = sourceObject.distributor.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)
            }

            if (sourceObject.parentGroup != null) {
                this.parentGroup = sourceObject.parentGroup.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)
            }
        }

        if (includeCustomProperties) {

        }

        if (includeDataList) {
            // No datalist
        }

        if (includeDynamicValues) {
            // No dynamicvalues
        }

        this.idTaskGroup = sourceObject.idTaskGroup
        this.idParentGroup = sourceObject.idParentGroup
        this.name = sourceObject.name
        this.dateCreated = sourceObject.dateCreated
        this.idDistributor = sourceObject.idDistributor
    }

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): OpTaskGroup {
        const result: OpTaskGroup = new OpTaskGroup(null)

        result.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return result
    }

    // #endregion

    // #region IJsonSerializable implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idTaskGroup = opObj.ID_TASK_GROUP
            this.idParentGroup = opObj.ID_PARRENT_GROUP // C# class has a typo, PARRENT instead of PARENT
            this.name = opObj.NAME
            this.dateCreated = opObj.DATE_CREATED
            this.idDistributor = opObj.ID_DISTRIBUTOR

            this.distributor = opObj._Distributor != null ? new OpDistributor(opObj._Distributor) : null
            this.parentGroup = opObj._ParentGroup != null ? new OpTaskGroup(opObj._ParentGroup) : null
            
            this.opState = opObj.OpState
        } else {
            this.idParentGroup = 0
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_LOCATION: this.idTaskGroup,
            ID_PARRENT_GROUP: this.idParentGroup,
            NAME: this.name,
            DATE_CREATED: this.dateCreated,
            ID_DISTRIBUTOR: this.idDistributor,

            _Distributor: this.distributor != null ? this.distributor.toJSON(compressed) : null,
            _ParentGroup: this.parentGroup != null ? this.parentGroup.toJSON(compressed): null,

            OpState: this.opState,
        }
    }

    // #endregion

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpTaskGroup[]): JQueryPromise<OpTaskGroup[]> {
        const defered: JQueryDeferred<OpTaskGroup[]> = $.Deferred<OpTaskGroup[]>()

        defered.resolve(list)

        return defered.promise()
    }
}